import { ReactElement } from 'react';
import { BrandedStoreSlice } from '@adapters/prismic/types/brandedStorePage';
import { PageType } from '@adapters/prismic/types/slices';
import { AlgonomyPlacement } from '@components/global/Recommendations/Loader';
import type { HitProps } from '@components/algolia/Hit';
import CategoryPageSliceHandler from '../CategoryPageSliceHandler';
import { HomepageSlice } from '@adapters/prismic/types/homepage';
import { sliceBleedAttributes } from '../sliceBleed';

import styles from './CategoryPageSliceZone.module.scss';

export interface BrandedStoreSliceZoneProps {
  slices?: BrandedStoreSlice[] | HomepageSlice[];
  categoryPageRecommendations?: AlgonomyPlacement[];
  isEnhancedPlp?: boolean;
  /** ED-345: SKU->product data resolved in getStaticProps for image_hotspot slices. */
  imageHotspotProducts?: Record<string, HitProps>;
}

const CategoryPageSliceZone = ({
  slices,
  categoryPageRecommendations,
  imageHotspotProducts,
}: BrandedStoreSliceZoneProps): ReactElement => (
  <div>
    {slices?.map((slice: BrandedStoreSlice | HomepageSlice, i: number) => (
      <section
        key={`category-page-slice-${slice?.id}`}
        className={styles.slice}
        {...sliceBleedAttributes(slice)}
      >
        <CategoryPageSliceHandler
          slice={slice}
          pageType={PageType.categoryInfoPage}
          sliceIndex={i}
          recommendations={categoryPageRecommendations}
          imageHotspotProducts={imageHotspotProducts}
        />
      </section>
    ))}
  </div>
);

export default CategoryPageSliceZone;
